import { useEffect, useState } from 'react';

/**
 * Hook to debounce a value. The debounced value will only update once the delay period has passed without the value changing.
 * @param {any} value - The value to debounce.
 * @param {number} delay - The delay period in milliseconds.
 * @returns {any} The debounced value.
 */
export default function useDebounce(value, delay) {
  // State for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Set debounced value to the current value after the delay period
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed within the delay period. Timeout gets cleared and restarted.
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Only re-call effect if value or delay changes

  return debouncedValue;
}
